import * as React from 'react';

type Props = {
  children: React.ReactNode;
};

const Empty = (props: Props) => {
  return (
    <div className="flex h-full w-full items-center justify-center text-xl text-muted-foreground">
      {props.children}
    </div>
  );
};

export default Empty;
